import { initIcons } from "./icons";

export function initToasts() {
  const syncToastOffset = () => {
    const topbar =
      document.querySelector(".topbar-mobile-sticky") ||
      document.querySelector(".navbar");

    const rect = topbar?.getBoundingClientRect?.();
    const bottom = Number(rect?.bottom || 0);
    const offset = bottom > 0 ? Math.round(bottom + 8) : 12;
    document.documentElement.style.setProperty("--app-toast-top", `${offset}px`);
  };

  if (!window.__toast_offset_bound) {
    window.__toast_offset_bound = true;
    window.addEventListener("resize", syncToastOffset, { passive: true });
    window.addEventListener("orientationchange", syncToastOffset, { passive: true });
    window.addEventListener("scroll", syncToastOffset, { passive: true });
    document.body.addEventListener("htmx:afterSwap", syncToastOffset);
    document.body.addEventListener("htmx:afterSettle", syncToastOffset);
  }

  syncToastOffset();

  // API global (DaisyUI alerts inside .toast)
  window.toast = (message, type = "info") => {
    syncToastOffset();
    const el = document.querySelector("#app-toasts");
    if (!el) return;

    const item = document.createElement("div");
    item.className = `alert alert-${type} shadow-lg`;
    // Iconos Lucide por tipo para mantener consistencia visual con el resto del panel.
    const iconByType = {
      success: "check",
      error: "x",
      warning: "triangle-alert",
      info: "info",
    };
    const icon = iconByType[type] || iconByType.info;
    item.innerHTML = `<i data-lucide="${icon}" aria-hidden="true"></i><span>${escapeHtml(message)}</span>`;
    el.appendChild(item);
    initIcons(item);

    setTimeout(() => item.remove(), 3500);
  };

  // 1) Toast desde querystring: ?toast=...&toast_type=success|error|warning|info
  try {
    const url = new URL(window.location.href);
    const msg = url.searchParams.get("toast");
    const type = url.searchParams.get("toast_type") || "info";

    if (msg) {
      window.toast(msg, type);

      // Limpia parámetros para que no reaparezca al refrescar
      url.searchParams.delete("toast");
      url.searchParams.delete("toast_type");
      history.replaceState({}, "", url.pathname + url.search + url.hash);
    }
  } catch {
    // noop
  }

  // 2) Toast “instantáneo” al click (ej: Descargar PDF en nueva pestaña)
  // Idempotencia compartida con pages/tickets.js para evitar toast duplicado.
  if (!window.__data_toast_bound) {
    window.__data_toast_bound = true;
    document.addEventListener("click", (e) => {
      const el = e.target?.closest?.("[data-toast]");
      if (!el) return;

      const msg = el.getAttribute("data-toast");
      if (!msg) return;

      const type = el.getAttribute("data-toast-type") || "info";
      window.toast(msg, type);
    });
  }
}

function escapeHtml(s) {
  return String(s)
    .replaceAll("&", "&amp;")
    .replaceAll("<", "&lt;")
    .replaceAll(">", "&gt;")
    .replaceAll('"', "&quot;")
    .replaceAll("'", "&#039;");
}
